import React from "react";
import ModalComponent from "components/modal";
import CreateLocation from "./CreateLocation";

function CreateLocationModal({
    showCreateLocationModal,
    handleCloseModal,
    isEdit,
    existingLocationData,
    onSuccess,
    readOnly,
    onSwitchToEdit,
}) {
    return (
        <ModalComponent
            open={showCreateLocationModal}
            header={readOnly ? "Location details" : isEdit ? "Edit Location" : "Add New Location"}
            borderedHeader
            size="large"
            onClose={handleCloseModal}
        >
            <CreateLocation
                onCancel={handleCloseModal}
                isEdit={isEdit}
                existingLocationData={existingLocationData}
                onSuccess={onSuccess}
                readOnly={readOnly}
                onSwitchToEdit={onSwitchToEdit}
            />
        </ModalComponent>
    );
}

export default CreateLocationModal;
